import {PaymentConfig} from '@/store/Constraints';
import {Axios,setAuthToken} from '@/api/Axios';

const PaymentStore = {
  state: {
    payAction:'', //PayActions(Payment/CancelPayment)
    payMethod:'', //PayMethodType = {PrePaid,Credit,Mobile,Exchange(결제금액이 0일때)}                  
    payMenuType:'',//PayMenuType = {Menu,Gift,Card}
    orderType:'', 
    order:null,
    store:null,
    prepaidResult:null,
  },
  getters:{
    [PaymentConfig.PAY_ACTION]: (state) => state.payAction,
    [PaymentConfig.PAY_METHOD]: (state) => state.payMethod,
    [PaymentConfig.PAY_MENU_TYPE]: (state) => state.payMenuType,
    [PaymentConfig.ORDER_TYPE]: (state) => state.orderType,
    [PaymentConfig.ORDER_DATA]: (state) => state.order,
    [PaymentConfig.ORDER_STORE]: (state) => state.store,
    [PaymentConfig.PRE_PAID_RESULT]: (state) => state.prepaidResult,

  },
  mutations:{
    [PaymentConfig.PAY_ACTION]:(state,payload) =>{
      console.log('PaymentStore.mutations.PAY_ACTION =>',payload);
      state.payAction = payload;
    },
    [PaymentConfig.PAY_METHOD]:(state,payload) =>{
      console.log('PaymentStore.mutations.PAY_METHOD =>',payload);
      state.payMethod = payload;
    },
    [PaymentConfig.PAY_MENU_TYPE]:(state,payload) =>{
      console.log('PaymentStore.mutations.PAY_MENU_TYPE =>',payload);
      state.payMenuType = payload;
    },
    [PaymentConfig.ORDER_TYPE]:(state,payload) =>{
      console.log('PaymentStore.mutations.ORDER_TYPE =>',payload);
      state.orderType = payload;
    },
    [PaymentConfig.ORDER_DATA]:(state,payload) =>{
      console.log(`PaymentStore.mutations.ORDER_DATA -> payload : ${JSON.stringify(payload)}`);
      state.order = payload;
    },
    [PaymentConfig.ORDER_STORE]:(state,payload) =>{
      console.log(`PaymentStore.mutations.ORDER_STORE -> payload : ${JSON.stringify(payload)}`);
      state.store = payload;
    },
    [PaymentConfig.PRE_PAID_RESULT]:(state,payload) =>{
      console.log(`PaymentStore.mutations.PRE_PAID_RESULT -> payload : ${JSON.stringify(payload)}`);
      state.prepaidResult = payload;
    },
    [PaymentConfig.INITIALIZE_PAYMENT_DATA]:(state,payload) =>{
      console.log('PaymentStore.mutations.INITIALIZE_PAYMENT_DATA =>',payload);    
      state.payAction=''
      state.payMethod=''
      state.payMenuType=''
      state.orderType=''
      state.order=null
      state.store=null
      state.prepaidResult=null
    }
  },
  actions:{
    [PaymentConfig.INITIALIZE_PAYMENT_DATA]:(store,payload) =>{    
      console.log('PaymentConfig.actions.INITIALIZE_PAYMENT_DATA =>',payload);
      store.commit(PaymentConfig.INITIALIZE_PAYMENT_DATA,payload)
  },
  }
}
export default PaymentStore;


// WEBPACK FOOTER //
// ./src/store/payment/PaymentStore.js